export const MOTE_FOR_SLIDES_CONTAINER_CLASS = 'mote-slides-container'
export const MOTE_FOR_SLIDES_FORMAT_MENU = 'docs-format-menu'
export const REWIND_SECONDS = 5
export const PLAYHEAD_MILLISECOND_INCREMENTS = 100
export const MIC_STATUS_ENUM = Object.freeze({
  prompt: 1,
  granted: 2,
  denied: 3
})
export const AUTH_DONE_TIMEOUT = 2000
export const INSERTION_ERROR_TIMEOUT = 90000
const OFFICE_EXTENSION_CLASS = 'office-editing-file-extension'

let audioStream = null

export async function queryMicPermission() {
  try {
    const { state } = await navigator.permissions.query({
      name: 'microphone'
    })

    return MIC_STATUS_ENUM[state]
  } catch (error) {
    return MIC_STATUS_ENUM.prompt
  }
}

export async function askForMicPermission() {
  try {
    audioStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    })

    return {
      status: MIC_STATUS_ENUM.granted
    }
  } catch (error) {
    let message

    console.log(error)

    switch (error.name) {
      case 'NotAllowedError':
        message = 'You have denied permission to your microphone!'
        break
      case 'NotFoundError':
        message = 'Microphone could not be found!'
        break
      default:
        message = 'Something went wrong!'
    }

    return {
      status: MIC_STATUS_ENUM.denied,
      message
    }
  }
}

export function cleanupMicStream() {
  if (!audioStream) return
  audioStream.getAudioTracks().forEach(track => {
    try {
      track.stop()
    } catch (e) {
      console.error('Failed to clean up mike stream', e)
    }
  })
}

// Whether Slides For Mote feature, as a whole is open (any modal/panel)
export function isMoteForSlidesActive() {
  const container = document.querySelector(
    `.${MOTE_FOR_SLIDES_CONTAINER_CLASS}`
  )

  if (!container) return false

  return container.hasChildNodes()
}

export function hasSlideEditAccess() {
  return document.getElementById(MOTE_FOR_SLIDES_FORMAT_MENU)
}

export function isPPTX() {
  const extensionElement = document.getElementById(OFFICE_EXTENSION_CLASS)
  return extensionElement && extensionElement.innerText
}
